export default __webpack_public_path__ + "static/media/img-16-coven.22d17804.jpg";